import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  declare templateTarget: HTMLTemplateElement
  declare containerTarget: HTMLElement

  add(event: Event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event: Event) {
    event.preventDefault()
    const wrapper = (event.target as HTMLElement).closest("[data-nested-form-wrapper]") as HTMLElement
    if (!wrapper) return

    const destroyInput = wrapper.querySelector("input[name*='_destroy']") as HTMLInputElement
    if (destroyInput) {
      // Persisted record — mark for destruction and hide
      destroyInput.value = "1"
      wrapper.classList.add("hidden")
    } else {
      // New record — remove from DOM entirely
      wrapper.remove()
    }
  }
}
